import React, {Fragment, useState} from "react";
import {Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import Loader from "../../../../../Layout/Loader";
import {Breadcrumbs, Btn, H5} from "../../../../../AbstractElements";
import BoardForm from "../Component/Form";
import SearchOptions from "../../../../CommonComponents/Search";
import BoardsTable from "../Component/BoardsTable";
import type {Board} from "../../Types/BoardTypes";

const BoardIndex = () => {
    const [loaderVisibility] = useState<boolean>(false);
    const [boardModalVisibility, setBoardModalVisibility] = useState<boolean>(false);
    const [searchVisibility, setSearchVisibility] = useState<boolean>(false);
    const [tableParams, setTableParams] = useState<any>({});
    const [reload, setReload] = useState<boolean>(false);

    const searchOptions = [{name: 'name'}, {name: 'collector_name', label: 'Collector'}, {
        name: 'collector_contact',
        label: 'Collector contact'
    }, {name: 'date'}];

    const boardModalToggle = () => {
        setBoardModalVisibility(!boardModalVisibility);
    }

    const addBoard = (_board: Board) => {
        boardModalToggle();
        setReload(!reload);
    }

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Boards" parent="Application" title="Boards"/>
            <Container fluid={true}>
                <Loader visibility={loaderVisibility}/>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className='d-flex align-items-center justify-content-between'>
                                <H5>Boards</H5>
                                <div>
                                    <div className='d-flex align-items-center gap-2'>
                                        <ButtonIcon attrBtn={{
                                            onClick: () => setBoardModalVisibility(true)
                                        }} type={'add'} permission={'create-board'}/>
                                        <ButtonIcon attrBtn={{
                                            onClick: () => setReload(!reload)
                                        }} type={'sync'} permission={'read-board'}/>
                                        <ButtonIcon attrBtn={{
                                            onClick: () => setSearchVisibility(!searchVisibility)
                                        }} type={'search'} permission={'read-board'}/>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {searchVisibility && <SearchOptions callBack={(params: any) => setTableParams(params)}
                                                                    searchOptions={searchOptions}/>}
                                <BoardsTable params={tableParams} reload={reload}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={boardModalVisibility} toggle={boardModalToggle} centered>
                <ModalHeader>
                    Create Board
                </ModalHeader>
                <ModalBody>
                    <BoardForm callBack={addBoard}/>
                </ModalBody>
                <ModalFooter>
                    <Btn attrBtn={{color: 'primary', onClick: boardModalToggle}}>Close</Btn>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default BoardIndex;
